import {SiCoursera,SiUdemy} from "react-icons/si";

const blogConfig = [
    {
        id: "blog-6",
        title: "IBM Data Engineering Professional Certificate",
        links: [
            {
                name: "course",
                url: "https://www.coursera.org/professional-certificates/ibm-data-engineer",
                icon: <SiCoursera/>
            }
        ],
        image: "https://www.freepnglogos.com/uploads/ibm-logo-png/ibm-logo-png-transparent-svg-vector-bie-supply-3.png",
        description: "Data Engineering. Master SQL, RDBMS, ETL, Data Warehousing, NoSQL, Big Data and Spark.",
        target: "_blank"
    },
    {
        id: "blog-5",
        title: "Data Engineering, Big Data, and Machine Learning on GCP Specialization",
        links: [
            {
                name: "course",
                url: "https://www.coursera.org/specializations/gcp-data-machine-learning",
                icon: <SiCoursera/>
            }
        ],
        image: "https://logodownload.org/wp-content/uploads/2021/06/google-cloud-logo-0.png",
        description: "Data Engineering on Google Cloud, delivering business value with big data and machine learning.",
        target: "_blank"
    },
    {
        id: "blog-4",
        title: "Microsoft Azure Data Engineering Associate DP-203 Exam Prep Specialization",
        links: [
            {
                name: "course",
                url: "https://www.coursera.org/specializations/microsoft-azure-dp-203-data-engineering",
                icon: <SiCoursera/>
            }
        ],
        image: "https://upload.wikimedia.org/wikipedia/commons/9/96/Microsoft_logo_%282012%29.svg",
        description: "Designing and implementing data solutions that use Microsoft Azure data services",
        target: "_blank"
    },
    {
        id: "blog-3",
        title: "Querying Microsoft SQL Server with Transact-SQL",
        links: [
            {
                name: "course",
                url: "https://www.udemy.com/course/70-461-session-2-querying-microsoft-sql-server-2012/",
                icon: <SiUdemy/>
            }
        ],
        image: "https://124135-361502-raikfcquaxqncofqfm.stackpathdns.com/asset/img/banners/features/supported-sources/sql-server.svg",
        description: "Advanced SQL and SQL",
        target: "_blank"
    },
    {
        id: "blog-2",
        title: "Apache Kafka - Real-time Stream Processing (Master Class)",
        links: [
            {
                name: "course",
                url: "https://www.udemy.com/course/kafka-streams-real-time-stream-processing-master-class/",
                icon: <SiUdemy/>
            }
        ],
        image: "https://upload.wikimedia.org/wikipedia/commons/5/53/Apache_kafka_wordtype.svg",
        description: "Processing Real-time Streams using Apache Kafka and Kafka Streams API.",
        target: "_blank"
    },
    {
        id: "blog-1",
        title: "Apache Kafka Series - Kafka Streams for Data Processing",
        links: [
            {
                name: "course",
                url: "https://www.udemy.com/course/kafka-streams/",
                icon: <SiUdemy/>
            }
        ],
        image: "https://upload.wikimedia.org/wikipedia/commons/e/e3/Udemy_logo.svg",
        description: "Kafka Streams API with Hands-On Examples Building and Deploying Apps with Java 8",
        target: "_blank"
    },
    {
        id: "blog-0",
        title: "Master Big Data - Apache Spark/Hadoop/Sqoop/Hive/Flume/Mongo",
        links: [
            {
                name: "course",
                url: "https://www.udemy.com/course/big-data-ingestion-using-sqoop-and-flume-cca-and-hdpcd/",
                icon: <SiUdemy/>
            }
        ],
        image: "https://upload.wikimedia.org/wikipedia/commons/1/10/Apache_HTTP_server_logo_%282019-present%29.svg",
        description: "In-depth course on Big Data - Apache Spark , Hadoop , Sqoop , Flume & Apache Hive, MongoDB & Big Data Cluster setup",
        target: "_blank"
    },
    {
        id: "blog-7",
        title: "Spark and Python for Big Data with PySpark",
        links: [
            {
                name: "course",
                url: "https://www.udemy.com/course/spark-and-python-for-big-data-with-pyspark/",
                icon: <SiUdemy/>
            }
        ],
        image: "https://upload.wikimedia.org/wikipedia/commons/f/f3/Apache_Spark_logo.svg",
        description: "Learning how to use Spark with Python, including Spark Streaming, Machine Learning, Spark 2.0 DataFrames.",
        target: "_blank"
    },
    {
        id: "blog-8",
        title: "The Ultimate Hands-On Hadoop: Tame your Big Data!",
        links: [
            {
                name: "course",
                url: "https://www.udemy.com/course/the-ultimate-hands-on-hadoop-tame-your-big-data/",
                icon: <SiUdemy/>
            }
        ],
        image: "https://upload.wikimedia.org/wikipedia/commons/0/0e/Hadoop_logo.svg",
        description: "Hadoop tutorial with over 25 technologies including MapReduce, HDFS, Spark, Flink, Hive, HBase, MongoDB, Cassandra, and Kafka.",
        target: "_blank"
    }
]

export default blogConfig